// Строка о пользовательском соглашении: экран входа на сайте и первый экран Mini App, где
// экрана входа нет. Оферту здесь не принимают — её принимают при оформлении заказа.
import { Link } from "react-router";

export function TermsLine({ className }: { className?: string }) {
  return (
    <p className={["text small muted", className].filter(Boolean).join(" ")}>
      Продолжая, ты принимаешь <Link to="/docs/terms">пользовательское соглашение</Link>. Как мы обращаемся с
      данными — в <Link to="/docs/privacy">политике</Link>
    </p>
  );
}
